import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';

export const OrderConfirmation = ({ orderNumber, onClose }) => {
  return (
    <>
      <div className="p-4 overflow-y-auto">
        <div className="mb-4">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight" style={{ fontWeight: 600 }}>
            Bestelling geplaatst
          </h1>
          <p className="text-gray-600 text-sm mt-2 font-normal">Bedankt voor uw vertrouwen</p>
        </div>

        <div className="space-y-2.5">
          {/* Success Card */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
            <div className="flex items-center gap-4 mb-4">
              <FaCheckCircle className="text-gray-900 text-4xl flex-shrink-0" />
              <div>
                <h3 className="text-xl font-bold text-gray-900">Bestelling succesvol ontvangen!</h3>
                <p className="text-sm text-gray-600 mt-1">Uw aanvraag is in behandeling</p>
              </div>
            </div>

            {orderNumber && (
              <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                <p className="text-xs font-semibold text-gray-600 mb-1 uppercase tracking-wide">Bestelnummer</p>
                <p className="text-2xl font-bold text-gray-900">{orderNumber}</p>
              </div>
            )}
          </div>

          {/* Confirmation Details */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4">
            <h3 className="text-base font-semibold text-gray-900 mb-3">Wat gebeurt er nu?</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gray-900 text-white flex items-center justify-center text-xs font-bold">
                  1
                </div>
                <div className="flex-1">
                  <p className="text-sm text-gray-700">
                    U ontvangt een bevestigingsmail met alle details van uw bestelling
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gray-900 text-white flex items-center justify-center text-xs font-bold">
                  2
                </div>
                <div className="flex-1">
                  <p className="text-sm text-gray-700">
                    Onze medewerkers bekijken uw aanvraag en nemen binnen 2 werkdagen contact met u op
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gray-900 text-white flex items-center justify-center text-xs font-bold">
                  3
                </div>
                <div className="flex-1">
                  <p className="text-sm text-gray-700">
                    Wij bespreken samen de details en plannen de levering en installatie
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="bg-gray-50 rounded-xl border border-gray-200 p-4">
            <h3 className="text-base font-semibold text-gray-900 mb-2">Vragen over uw bestelling?</h3>
            <p className="text-sm text-gray-700">
              Neem gerust contact met ons op. Vermeld hierbij uw bestelnummer <strong>{orderNumber}</strong> voor een snellere afhandeling.
            </p>
          </div>

          {/* Action Button */}
          <div className="pt-2">
            <button
              onClick={onClose}
              className="w-full text-white bg-gray-900 hover:bg-gray-800 focus:ring-2 focus:outline-none focus:ring-gray-400 font-semibold rounded-xl text-base px-6 py-3.5 text-center transition-all duration-200 shadow-md hover:shadow-lg"
            >
              Terug naar configurator
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
